import React from "react";
import CIcon from "@coreui/icons-react";
import { jwtDecode } from "jwt-decode";
import {
  cilIndustry,
  cilPuzzle,
  cilGroup,
  cilBeaker,
  cilDescription,
  cilCalculator,
  cilFolderOpen,
  cilWallet,
  cilChartLine,
  cilCalendar,
  cilLightbulb,
  cilSearch,
  cilSpeech,
  cilList,
  cilTruck,
  cilAirplaneMode,
  cilZoom,
  cilAsterisk,
  cilSmile,
  cilBuilding,
  cilBarChart,
  cilFax,
  cilDrinkAlcohol,
  cilPeople,
  cilAlarm,
  cilReportSlash,
  cilSchool,
  cilBullhorn,
  cilSpeedometer,
  cilShieldAlt,
  cilClipboard,
  cilMediaPlay,
  cilEuro,
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react";

const token = localStorage.getItem("access_token");
const currentYear = new Date().getFullYear().toString();
const surveyYear = String(Number(currentYear) - 1);
let is_manager = false;
let is_staff = false;
let can_access_billing_updates_email = false;
let can_access_competitive_analysis = false;
if (token) {
  try {
    const decodedToken = jwtDecode(token);
    is_manager = !!decodedToken.is_manager;
    is_staff = !!decodedToken.is_staff;
    can_access_billing_updates_email =
      !!decodedToken.can_access_billing_updates_email;
    can_access_competitive_analysis =
      !!decodedToken.can_access_competitive_analysis;
  } catch (error) {
    console.error("Token decode error in navigation:", error);
  }
}

const _nav = [
  {
    component: CNavTitle,
    name: "Geral",
  },
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/",
    icon: <CIcon icon={cilClipboard} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Gestão Interna",
    icon: <CIcon icon={cilFax} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Férias",
        className: "ms-3",
        icon: <CIcon icon={cilDrinkAlcohol} customClassName="nav-icon" />,
        to: "/interno/ferias",
      },
      {
        component: CNavItem,
        name: "Ausências",
        className: "ms-3",
        icon: <CIcon icon={cilAlarm} customClassName="nav-icon" />,
        to: "/interno/ausencias",
      },
    ],
  },
  {
    component: CNavItem,
    name: "Formações / Eventos",
    to: "/formacoes-eventos",
    icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Indicadores",
    icon: <CIcon icon={cilBarChart} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Matriz Indicadores",
        to: "/matriz-indicadores",
      },
      {
        component: CNavItem,
        name: "Resultados Indicadores",
        to: "/resultados-indicadores",
      },
      {
        component: CNavItem,
        name: "Objetivos Funcionais",
        to: "/objetivos-funcionais",
      },
    ],
  },
  {
    component: CNavTitle,
    name: "Projetos",
  },
  {
    component: CNavItem,
    name: "Sessões de Arranque",
    icon: <CIcon icon={cilList} customClassName="nav-icon" />,
    to: "/sessoes-arranque",
  },
  {
    component: CNavGroup,
    name: "Candidaturas",
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Inovação",
        className: "ms-3",
        icon: <CIcon icon={cilIndustry} customClassName="nav-icon" />,
        to: "/candidaturas/inovacao",
      },
      {
        component: CNavItem,
        name: "I&DT",
        className: "ms-3",
        icon: <CIcon icon={cilBeaker} customClassName="nav-icon" />,
        to: "/candidaturas/idt",
      },
      {
        component: CNavItem,
        name: "Internacionalização",
        className: "ms-3",
        icon: <CIcon icon={cilAirplaneMode} customClassName="nav-icon" />,
        to: "/candidaturas/internacionalizacao",
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Gestão",
    icon: <CIcon icon={cilFolderOpen} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Kickoff",
        className: "ms-3",
        icon: <CIcon icon={cilMediaPlay} customClassName="nav-icon" />,
        to: "/projetos/kickoff",
      },
      {
        component: CNavItem,
        name: "Tarefas",
        className: "ms-3",
        icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
        to: "/projetos/feed",
      },
      {
        component: CNavItem,
        name: "Recursos",
        className: "ms-3",
        icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
        to: "/projetos/recursos",
      },
      {
        component: CNavItem,
        name: "Sabrina",
        className: "ms-3",
        icon: <CIcon icon={cilZoom} customClassName="nav-icon" />,
        to: "/projetos/vigilancia",
      },
      {
        component: CNavItem,
        name: "Roberto",
        className: "ms-3",
        icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
        to: "/projetos/gestao",
      },
    ],
  },
  {
    component: CNavItem,
    name: "KPIs",
    icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
    to: "/projetos/kpis",
  },
  {
    component: CNavItem,
    name: "Projetos Financiados",
    icon: <CIcon icon={cilEuro} customClassName="nav-icon" />,
    to: "/projetos/fundos-europeus",
  },
  {
    component: CNavTitle,
    name: "SGQ",
  },
  {
    component: CNavItem,
    name: "Ideias/Sugestões",
    icon: <CIcon icon={cilLightbulb} customClassName="nav-icon" />,
    to: "/ideias",
  },
  {
    component: CNavItem,
    name: "Não Conformidades",
    icon: <CIcon icon={cilReportSlash} customClassName="nav-icon" />,
    to: "/nao-conformidades",
  },
  {
    component: CNavItem,
    name: "Reclamações",
    icon: <CIcon icon={cilBullhorn} customClassName="nav-icon" />,
    to: "/reclamacoes",
  },
  {
    component: CNavGroup,
    name: "Ações de Melhoria",
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Oportunidades Melhoria",
        to: "/oportunidades-melhoria",
        className: "text-wrap text-break ms-3",
      },
      {
        component: CNavItem,
        name: "Ações Melhoria",
        to: "/acoes-melhoria",
        className: "text-wrap text-break ms-3",
      },
    ],
  },
  {
    component: CNavItem,
    name: "Lições Apreendidas",
    icon: <CIcon icon={cilSchool} customClassName="nav-icon" />,
    to: "/licoes-aprendidas",
  },
  {
    component: CNavItem,
    name: "Propriedade Intelectual",
    icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
    to: "/propriedade-intelectual",
  },
  {
    component: CNavTitle,
    name: "Inovação",
  },
  {
    component: CNavGroup,
    name: "IDI: Ideias/Projetos",
    icon: <CIcon icon={cilLightbulb} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Ideias Inovadoras",
        to: "/ideias-inovadoras",
        className: "text-wrap text-break ms-3",
      },
      {
        component: CNavItem,
        name: "Banco de Ideias",
        to: "/banco-ideias",
        className: "text-wrap text-break ms-3",
      },
      {
        component: CNavItem,
        name: "Ações de Inovação",
        to: "/acoes-inovacao",
        className: "text-wrap text-break ms-3",
      },
      {
        component: CNavItem,
        name: "Projetos IDI",
        to: "/projetos-idi",
        className: "text-wrap text-break ms-3",
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Parcerias",
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Lista",
        to: "/parcerias",
        className: "text-wrap text-break ms-3",
      },
      {
        component: CNavItem,
        name: "Inquéritos IDI",
        to: "/inqueritos-idi",
        className: "text-wrap text-break ms-3",
      },
    ],
  },
  {
    component: CNavItem,
    name: "Estágios",
    to: "/estagios",
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Vigilância Interfaces",
    icon: <CIcon icon={cilSearch} customClassName="nav-icon" />,
    to: "/vigilancia-interfaces",
  },
  ...(can_access_competitive_analysis
    ? [
        {
          component: CNavGroup,
          name: "Análise concorrência",
          icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
          items: [
            {
              component: CNavItem,
              name: "Empresas",
              to: "/empresas-concorrentes",
            },
            {
              component: CNavItem,
              name: "Análise Empresas Concorrentes",
              to: "/analise-concorrencia",
              className: "text-wrap text-break",
            },
          ],
        },
      ]
    : []),
  {
    component: CNavTitle,
    name: "Stakeholders",
  },
  {
    component: CNavGroup,
    name: "Clientes",
    icon: <CIcon icon={cilWallet} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Lista",
        className: "ms-3",
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
        to: "/clientes",
      },
      ...(can_access_billing_updates_email
        ? [
            {
              component: CNavItem,
              name: "Atualizações de Faturação",
              className: "ms-3 text-wrap text-break",
              icon: <CIcon icon={cilSpeech} customClassName="nav-icon" />,
              to: "/clientes/atualizacoes-faturacao",
            },
          ]
        : []),
      {
        component: CNavGroup,
        name: "Questionários de Satisfação",
        className: "ms-3",
        icon: <CIcon icon={cilSpeech} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: "Questionários",
            to: "/questionarios-satisfacao",
            className: "text-wrap text-break ms-3",
          },
          {
            component: CNavItem,
            name: "Presencial",
            to: "/questionarios-satisfacao-presencial",
            className: "text-wrap text-break ms-3",
          },
        ],
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Fornecedores",
    icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Lista",
        to: "/fornecedores",
        className: "text-wrap text-break ms-3",
      },
      {
        component: CNavItem,
        name: "Avaliação",
        to: `avaliacao-fornecedores`,
        className: "text-wrap text-break ms-3",
      },
      ...(is_staff || is_manager
        ? [
            {
              component: CNavItem,
              name: "Ponderações",
              to: "/ponderacoes-avaliacao-fornecedores",
              className: "text-wrap text-break ms-3",
            },
          ]
        : []),
    ],
  },
  {
    component: CNavTitle,
    name: "Colaboradores",
  },
  {
    component: CNavGroup,
    name: "Inquéritos Colaboradores",
    icon: <CIcon icon={cilSpeech} customClassName="nav-icon" />,
    items: [
      {
        component: CNavGroup,
        name: "Inquéritos SST",
        icon: <CIcon icon={cilAsterisk} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: "Inquéritos",
            to: "/inqueritos-sst",
            className: "text-wrap text-break ms-3",
          },
          {
            component: CNavItem,
            name: "Resultados",
            to: `inqueritos-sst/resultados/${surveyYear}`,
            className: "text-wrap text-break ms-3",
          },
        ],
      },
      {
        component: CNavGroup,
        name: "Inquéritos Felicidade",
        icon: <CIcon icon={cilSmile} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: "Inquéritos",
            to: "/inqueritos-felicidade",
            className: "text-wrap text-break ms-3",
          },
          {
            component: CNavItem,
            name: "Resultados",
            to: `inqueritos-felicidade/resultados/${surveyYear}`,
            className: "text-wrap text-break ms-3",
          },
        ],
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Avaliação",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Chefias",
        to: "/avaliacao-chefias",
      },
      {
        component: CNavItem,
        name: "Desempenho",
        to: "/avaliacao-desempenho",
        className: "text-wrap text-break",
      },
      ...(is_manager
        ? [
            {
              component: CNavItem,
              name: "Ponderações Avaliação Desempenho",
              to: "/ponderacoes-avaliacao-desempenho",
              className: "text-wrap text-break",
            },
          ]
        : []),
    ],
  },
  {
    component: CNavTitle,
    name: "Configurações",
  },
  {
    component: CNavItem,
    name: "Utilizadores",
    to: "/utilizadores",
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  },
  ...(is_staff || is_manager
    ? [
        {
          component: CNavItem,
          name: "Departamentos",
          to: "/departamentos",
          icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />,
        },
      ]
    : []),
];

export default _nav;
